import styled from 'styled-components';
import { LinkTabs } from 'UI';

export const SButtonTabs = styled(LinkTabs)`
  font-weight: 'bold';
`;
